import { sendsOnEnter, type KeyIntent } from './composing';
import { appendDictation } from './speech';

export interface ComposerAvailability {
  readonly disabled?: boolean;
  readonly busy?: boolean;
  readonly maxLength?: number;
}

function validMaxLength(maxLength: number | undefined): number | null {
  if (maxLength === undefined || !Number.isInteger(maxLength) || maxLength < 1) return null;
  return maxLength;
}

export function boundedComposerText(value: string, maxLength?: number): string {
  const limit = validMaxLength(maxLength);
  return limit === null ? value : value.slice(0, limit);
}

export function composerCanSend(value: string, availability: ComposerAvailability = {}): boolean {
  if (availability.disabled === true || availability.busy === true) return false;
  const limit = validMaxLength(availability.maxLength);
  if (limit !== null && value.length > limit) return false;
  return value.trim().length > 0;
}

export function composerSendsOnKey(
  event: KeyIntent,
  value: string,
  availability: ComposerAvailability = {},
): boolean {
  return sendsOnEnter(event) && composerCanSend(value, availability);
}

export function composerDraftAfterDictation(
  existing: string,
  dictated: string,
  maxLength?: number,
): string {
  return boundedComposerText(appendDictation(existing, dictated), maxLength);
}
